/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserList } from './userList';


import {ValidatorFn, Validators} from "@angular/forms";

export interface PaginatedUserListList { 
    next?: string | null;
    previous?: string | null;
    results: Array<UserList>;
}
export const PaginatedUserListList_next_Validators: ValidatorFn[] =
    [ ];

export const PaginatedUserListList_previous_Validators: ValidatorFn[] =
    [ ];

export const PaginatedUserListList_results_Validators: ValidatorFn[] =
    [  Validators.required, ];


